import { useEffect, useState } from 'react'
import { useAuthStore } from '@/store/authStore'
import { webSocketService } from '@/services/websocket'

export function useInitializeApp() {
  const [isInitializing, setIsInitializing] = useState(true)
  const { checkAuth, isAuthenticated } = useAuthStore()

  useEffect(() => {
    async function initializeApp() {
      try {
        // Check authentication status
        await checkAuth()
        
        // Initialize WebSocket connection if authenticated
        if (isAuthenticated) {
          // WebSocket service is initialized automatically
        }
      } catch (error) {
      } finally {
        setIsInitializing(false)
      }
    }

    initializeApp()
  }, [checkAuth, isAuthenticated])

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      webSocketService.disconnect()
    }
  }, [])

  return { isInitializing }
}